import * as React from 'react';
import { useParams } from 'react-router';

import { UserRole } from '@shared/types/user_role';

import { Roles } from '@admin/components/helpers/roles';
import { Spinner } from '@admin/components/spinner';
import { opsAuditConfigurationsURL } from '@admin/config/routes';
import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import { useOpsAuditConfigurationQuery } from '@admin/schema';

import { OpsAuditConfigurationForm, EditFormData } from './form/form';

export const OpsAuditEditConfiguration: React.FC = () => {
  useTitle('Edit Ops Audit Configuration');
  const { id } = useParams<{ id: string }>();
  const { data, loading } = useOpsAuditConfigurationQuery({ client, variables: { id: id } });

  if (loading || !data?.opsAuditConfiguration) {
    return <Spinner />;
  }

  const auditConfig = data.opsAuditConfiguration;

  const formData: EditFormData = {
    id: auditConfig.id,
    refreshIntervalMinutes: auditConfig.refreshIntervalMinutes ?? undefined,
    hoursUntilExpired: auditConfig.hoursUntilExpired ?? undefined,
    name: auditConfig.name,
    dataQuery: auditConfig.dataQuery,
    exceptionReasonCodes: auditConfig.exceptionReasonCodes,
    questions: auditConfig.questions,
  };

  const onSubmit = async () => {
    window.location.href = opsAuditConfigurationsURL();
  };

  return (
    <Roles show={[UserRole.Admin]}>
      <OpsAuditConfigurationForm formData={formData} onSave={onSubmit} />
    </Roles>
  );
};
